import { Environment } from '@abp/ng.core';

const baseUrl = 'https://host.hyyak.com';
const authFrontendUrl = 'https://login.hyyak.com';
const guestUrl = 'https://hyyak.com';

const oAuthConfig = {
  issuer: 'https://auth.hyyak.com/',
  redirectUri: baseUrl,
  postLogoutRedirectUri: baseUrl,
  clientId: 'Hyyak_Host',
  responseType: 'code',
  scope: 'openid profile email phone roles offline_access Hyyak',
  requireHttps: true,
};

export const environment = {
  authFrontendUrl,
  guestUrl,
  production: false,
  application: {
    baseUrl,
    name: 'Hyyak',
  },
  oAuthConfig,
  apis: {
    default: {
      url: 'https://api.hyyak.com',
      rootNamespace: 'Hyyak',
    },
    AbpAccountPublic: {
      url: oAuthConfig.issuer,
      rootNamespace: 'AbpAccountPublic',
    },
  },
} as Environment;